import { createContext, useContext, useState, useCallback, useRef } from "react";
import { tokenStore, KEYS } from "../lib/storage";

const GameContext = createContext(null);

export const GameProvider = ({ children }) => {
  const [token, setToken] = useState(() => tokenStore.get(KEYS.SESSION_TOKEN) || "");
  const [code, setCode] = useState(() => tokenStore.get(KEYS.SESSION_CODE) || "");
  const [session, setSession] = useState(null);
  const [videoBlob, setVideoBlob] = useState(null);
  const [compositeVideoBlob, setCompositeVideoBlobState] = useState(null);
  const compositeVideoBlobRef = useRef(null);
  const streamRef = useRef(null);

  const setCompositeVideoBlob = useCallback((blob) => {
    compositeVideoBlobRef.current = blob?.size ? blob : null;
    setCompositeVideoBlobState(blob?.size ? blob : null);
  }, []);

  const saveToken = useCallback((t, c) => {
    setToken(t);
    setCode(c);
    tokenStore.set(KEYS.SESSION_TOKEN, t);
    tokenStore.set(KEYS.SESSION_CODE, c);
  }, []);

  const clearAuth = useCallback(() => {
    setToken("");
    setCode("");
    setSession(null);
    setVideoBlob(null);
    compositeVideoBlobRef.current = null;
    setCompositeVideoBlobState(null);
    tokenStore.remove(KEYS.SESSION_TOKEN);
    tokenStore.remove(KEYS.SESSION_CODE);
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    }
  }, []);

  const value = {
    token,
    code,
    session,
    setSession,
    videoBlob,
    setVideoBlob,
    compositeVideoBlob,
    compositeVideoBlobRef,
    setCompositeVideoBlob,
    streamRef,
    saveToken,
    clearAuth,
  };

  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
};

export const useGame = () => {
  const ctx = useContext(GameContext);
  if (!ctx) throw new Error("useGame must be used within GameProvider");
  return ctx;
};
